<script setup lang="js">
const props = defineProps({
  color: ''
})
</script>

<template>
  <div class="">
    <div class="container mx-auto lg:py-[1.5rem] md:py-[1rem] py-[1rem] px-4">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>

</style>
